import { render, staticRenderFns } from "./ImagePostCreator.vue?vue&type=template&id=640521ee&scoped=true&"
import script from "./ImagePostCreator.vue?vue&type=script&lang=js&"
export * from "./ImagePostCreator.vue?vue&type=script&lang=js&"
import style0 from "./ImagePostCreator.vue?vue&type=style&index=0&id=640521ee&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640521ee",
  null
  
)

export default component.exports